import React, { useState } from 'react';
import { Row, Col, Card, CardBody, Collapse } from 'reactstrap';
import { Form } from '@availity/form';
import { Input, Select, Switch, FieldArray } from '../../lib/form-field';
import formValidation from './formValidation';

import * as countriesActions from '../../store/countries/actions';
import { useDispatch } from 'react-redux';

import companyPhoneExchanges from '../../config/companyPhoneExchanges';
import TIMEZONES from '../../config/timezones';
import LANGUAGE_TAGS from '../../config/languageTags';
import { SubmitButton } from '../Common/Modal/modalActionButtons';

const FormCountry = (props) => {
  const editingCountry = props.country || {};

  const facebookAdAccountIds = editingCountry.facebookAdAccountIds || [];

  const [active, setActive] = useState(editingCountry.active || false);
  const [facebookModule, setFacebookModule] = useState(
    editingCountry.facebookModule || false,
  );
  const [googleModule, setGoogleModule] = useState(
    editingCountry.googleModule || false,
  );
  const [supplierModule, setSupplierModule] = useState(
    editingCountry.supplierModule || false,
  );
  const [audienceModule, setAudienceModule] = useState(
    editingCountry.audienceModule || false,
  );
  const [landingPageModule, setLandingPageModule] = useState(
    editingCountry.landingPageModule || false,
  );

  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    const countryData = {
      ...values,
      active,
      facebookModule,
      googleModule,
      supplierModule,
      audienceModule,
      landingPageModule,
    };

    dispatch(
      props.create
        ? countriesActions.createCountry(countryData)
        : countriesActions.updateCountry({
            id: editingCountry.id,
            ...countryData,
          }),
    );
    props.closeModal();
  };

  return (
    <Card>
      <CardBody>
        <Form
          initialValues={{
            ...editingCountry,
            facebookAdAccountIds,
            facebookModule,
            googleModule,
            supplierModule,
            audienceModule,
            landingPageModule,
          }}
          validationSchema={formValidation}
          onSubmit={handleSubmit}>
          {({ isValid, values }) => (
            <>
              <Row>
                <Col md="3">
                  <Input type="text" name="name" id="name" />
                </Col>
                <Col md="2">
                  <Input
                    type="text"
                    id="countryCode"
                    name="countryCode"
                    label="Country Code"
                  />
                  <p className="font-size-12 text-muted">
                    Ex. US, UK, etc. (ISO 3166-1 alpha-2)
                  </p>
                </Col>
                <Col md="3">
                  <Input
                    id="waitingTimeRecall"
                    name="waitingTimeRecall"
                    label="Waiting Time Recall"
                    min={0.5}
                    type="number"
                    step="0.1"
                  />
                  <p className="font-size-12 text-muted">
                    In hours (ex. 0,5 or 2)
                  </p>
                </Col>
                <Col md="2">
                  <Switch
                    name="active"
                    label="Active?"
                    defaultChecked={active}
                    onClick={() => setActive(!active)}
                  />
                </Col>
              </Row>
              <Row>
                <Col md="3">
                  <Select
                    name="phoneExchange"
                    id="phoneExchange"
                    label="Phone Exchange"
                    isMulti={false}
                    options={companyPhoneExchanges}
                  />
                </Col>
                <Col md="3">
                  <Select
                    name="timezone"
                    id="timezone"
                    label="Timezone"
                    isMulti={false}
                    options={TIMEZONES}
                  />
                </Col>
                <Col md="3">
                  <Select
                    name="languageTag"
                    id="languageTag"
                    label="Language"
                    isMulti={false}
                    options={LANGUAGE_TAGS}
                  />
                  <p className="font-size-12 text-muted">
                    Used as default language for landing pages
                  </p>
                </Col>
              </Row>
              <Row>
                <Col md="2">
                  <Switch
                    name="facebookModule"
                    label="Facebook Module"
                    defaultChecked={facebookModule}
                    onClick={() => setFacebookModule(!facebookModule)}
                  />
                </Col>
                <Col md="2">
                  <Switch
                    name="googleModule"
                    label="Google Module"
                    defaultChecked={googleModule}
                    onClick={() => setGoogleModule(!googleModule)}
                  />
                </Col>
                <Col md="2">
                  <Switch
                    name="supplierModule"
                    label="Supplier Module"
                    defaultChecked={supplierModule}
                    onClick={() => setSupplierModule(!supplierModule)}
                  />
                </Col>
                <Col md="2">
                  <Switch
                    name="audienceModule"
                    label="Audience Module"
                    defaultChecked={audienceModule}
                    onClick={() => setAudienceModule(!audienceModule)}
                  />
                </Col>
                <Col md="2">
                  <Switch
                    name="landingPageModule"
                    label="Landing Page Module"
                    defaultChecked={landingPageModule}
                    onClick={() => setLandingPageModule(!landingPageModule)}
                  />
                </Col>
              </Row>
              <Collapse isOpen={facebookModule}>
                <Row>
                  <Col md="6">
                    <FieldArray
                      name="facebookAdAccountIds"
                      label="Facebook Ad Account Ids"
                      values={values}
                      defaultItem={{ accountId: '', datasetId: '' }}
                      fields={[
                        { name: 'accountId', label: 'Account ID', col: 5 },
                        { name: 'datasetId', label: 'Dataset ID', col: 5 },
                      ]}
                    />
                  </Col>
                  <Col md="6">
                    <Input
                      type="textarea"
                      name="facebookAccessToken"
                      id="facebookAccessToken"
                      label="Facebook Access Token"
                    />
                  </Col>
                </Row>
              </Collapse>
              <div className="modal-footer">
                <SubmitButton
                  disabled={!isValid || props.loading}
                  create={props.create}
                />
              </div>
            </>
          )}
        </Form>
      </CardBody>
    </Card>
  );
};

export default FormCountry;
